module.exports = __webpack_public_path__ + "img/vital-white.5d26a546.svg";